import "./StudentManagement.scss";
import React, { useState } from "react";
import MessageReport from "./message-report";
import PostReport from "./post-report";

const ReportManagement = () => {
  const [propertyTab, setPropertyTab] = useState("post-report");

  return (
    <>
      <div className="student_management">
        <div className="dashboard_title">
          <h3>Report Management</h3>
        </div>

        <div className="wrapper_cstm_tabers" style={{ marginBottom: "20px" }}>
          <ul style={{ paddingLeft: "0px" }}>

            <li
              className={propertyTab === "post-report" ? "active" : ""}
              onClick={() => setPropertyTab("post-report")}
            >
              Post
            </li>
            <li
              className={propertyTab === "message-report" ? "active" : ""}
              onClick={() => setPropertyTab("message-report")}
            >
              Comment
            </li>

          </ul>
        </div>

        {
          propertyTab === "post-report" && (
            <PostReport />
          )
        }

        {
          propertyTab === "message-report" && (
            <MessageReport />
          )
        }
      </div>
    </>
  );
};

export default ReportManagement;
